import { reactive, ref } from "vue";

export default {
  name: 'FormInputComponent',
  props: {
    type: {
      type: String,
      required: false,
      default: 'text',
    },
    name: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: false,
      default: null,
    },
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      defaul: null,
    },
    readonly: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: String,
      required: false,
      default: null,
    },
    error: {
      type: String,
      required: false,
      default: null,
    },
    success: {
      type: String,
      required: false,
      default: null,
    },
    autocomplete: {
      type: String,
      required: false,
      default: 'on',
    },
  },
  setup(props) {
    const state = reactive({
      value: ref(props.value),
      length: ref(props.value ? props.value.length : 0),
      maxLength: ref(props.maxLength)
    });

    const checkForTerm = () => {
      const decoded = decodeURIComponent(window.location.search)
      const query = decoded.replace('?', '')
      let qs = ''
      // check if page is the first parameter in the query string
      if (query.startsWith('page=')) {
        const regex = '[^_page=\\d{1,}'
        const exists = query.match(regex)
        if (exists) {
          qs = query.replace(exists[0], 'page=1')
        }
        else {
          qs = query
        }
      }
      else {
        const regex = '[&]page=\\d{1,}'
        const exists = query.match(regex)
        if (exists) {
          qs = query.replace(exists[0], '&page=1')
        }
        else {
          qs = query
        }
      }

      const parts = qs.split('&')
      for (const part of parts) {
        if (part.startsWith('filter[term]')) {
          return state.value = part.split('=')[1]
        }
      }
    }

    checkForTerm();

    return { state };
  },
  methods: {
    validate: async function(name) {
      this.state.value = this.state.value;
      if (this.state.maxLength && this.state.value && this.state.value.length > this.state.maxLength) {
        this.state.value = this.state.value.substring(0, this.state.maxLength);
      }
      this.$emit('update', { key: name, value: this.state.value });
    },
    lengthClass: function() {
      if (!this.state.value) {
        return 'koc-count-default';
      }
      const value = this.state.value.length / this.state.maxLength;
      if (value >= 1) {
        return 'koc-count-danger';
      }
      if (value >= .7) {
        return 'koc-count-warning';
      }
      return 'koc-count-success';
    },
    clear: function() {
      this.state.value = null;
    }
  }
};
